@if (!actAsModal()) {
<div class="work-office-megasearch-input">
  <div
    [class.disabled]="disabled()"
    [class.editable]="editable()"
    [class.error]="invalid()"
    [class.icon]="iconName()"
    [class.readonly]="readonly()"
    [class.table-input]="tableInput()"
    [class.with-label]="label() && iconName()"
    [style.max-width]="maxWidth() + 'px'"
    [style.width]="width() + 'px'"
    class="work-ui-select work-input cursor-pointer"
  >
    @if (label()) {
    <label>
      <ng-template #labelContent>
        <b
          >{{ label() | translate }}
          @if (required()) {
          <b class="work-text-required-asterisk"> *</b>
          }</b
        >
      </ng-template>

      @switch (labelSize()) { @case ('small') {
      <small>
        <ng-container *ngTemplateOutlet="labelContent" />
      </small>
      } @case ('default') {
      <p>
        <ng-container *ngTemplateOutlet="labelContent" />
      </p>
      } }
    </label>
    }
    <div class="input-wrapper">
      <div
        (click)="openModal()"
        [class.disabled]="disabled()"
        [class.readonly--no-borders]="readonlyNoBorders()"
        [class.readonly]="readonly()"
        class="work-ui-select__custom"
        tabindex="0"
      >
        <div class="work-ui-select__selected-option width-100">
          @if (searchTerm()) {
          <p class="work-ui-select__selected-option-text">{{ searchTerm() | translate }}</p>
          } @else {
          <span class="placeholder">{{ placeholder() | translate }}</span>
          }
        </div>
        @if (searchTerm()) {
        <work-ui-icon (click)="clearValue(); $event.stopPropagation()" class="arrow-down" name="close" />
        }
      </div>

      @if (iconName()) {
      <work-ui-icon [name]="iconName()" />
      }
    </div>
    @if (!disableHint()) {
    <span [class.hide]="hideHint()" [style.opacity]="invalid() ? '1' : '0'" class="work-input__hint">
      <small
        ><b>{{ hintMessage() | translate }}</b></small
      >
    </span>
    }
  </div>
</div>
}

<work-ui-modal
  #megaSearchModal
  (modalClosed)="handleModalClosed()"
  [anchoredTop]="true"
  [closableOnOutsideClick]="true"
  [hideCloseButton]="true"
  [noBodyPadding]="true"
  [noFooter]="true"
  modalId="userListModal"
  modalWidth="large"
>
  <ng-container modal-body>
    @if (megaSearchModal.isOpen) {
    <div class="padding-24">
      <div class="flex flex-row vertical-center gap-12 space-between">
        <work-ui-input-field
          (valueChange)="searchForValue($event)"
          [(loadingState)]="searchLoadingState"
          [placeholder]="placeholder()"
          [disableError]="true"
          [showClearButton]="showClearButton()"
          [value]="searchTerm()"
          workUiAutofocus
          iconName="search"
          name="search"
          type="search"
        />
        <work-ui-button (buttonClick)="megaSearchModal.close()" iconName="close" variant="secondary" [iconOnly]="true" size="small" />
      </div>
      @if (containerTypeIdFilters().length > 0) {
      <div class="margin-top-24 flex flex-row vertical-center gap-24 wrap">
        @for (containerType of containerTypes(); track containerType.id) {
        <work-ui-checkbox
          [label]="containerType.name ? containerType.name : ''"
          [checked]="containerTypeIdFilters().includes(containerType.id) || false"
          (checkedChange)="updateContainerTypeIdFilter(containerType.id, $event)"
          [noMargin]="true"
        />
        }
      </div>
      }
    </div>
    <div class="work-office-megasearch-input__results" [class.show]="WorkMegasearchResultDto() !== undefined">
      <work-office-global-megasearch-results
        (contactClicked)="handleContactClicked($event)"
        (projectClicked)="handleProjectClicked($event)"
        (userClicked)="handleUserClicked($event)"
        (equipmentClicked)="handleEquipmentClicked($event)"
        (stocklocationClicked)="handleStocklocationClicked($event)"
        (itemClicked)="handleItemClicked($event)"
        [(isVisible)]="isSearchVisible"
        [disableResultContactLinks]="disableResultContactLinks()"
        [disableResultProjectLinks]="disableResultProjectLinks()"
        [containerTypeIdFilters]="containerTypeIdFilters()"
        [showAsOverlay]="false"
        [alignment]="alignment()"
        [WorkMegasearchResultDto]="WorkMegasearchResultDto()"
        [searchterm]="searchTerm()"
      />
    </div>
    }
  </ng-container>
</work-ui-modal>
